import { segmentTrackApiWrapper } from '@api-v2/segment';
import { SegmentEvents } from '@constants/SegementEvents';
import * as UpChunk from '@mux/upchunk';

export const UPLOAD_MUX_VIDEO_ERROR_MSG = 'Video upload error'

export const uploadAssetToMux = async (uploadUrl: string, data: File) => {
  const offlineTimeWait = 10000
  let offlineTimeout: any

  const uploadFile = new Promise<void>((resolve, reject) => {
    const upload = UpChunk.createUpload({
      endpoint: uploadUrl,
      file: data,
      attempts: 3,
      chunkSize: 30720,
    });

    upload.on('error', err => {
      void segmentTrackApiWrapper(SegmentEvents.ErrorMessageThrown, {
        errorTitle: 'Failed to upload asset to Mux',
        error: 'Failed to upload: ' + err.detail,
        source: 'share',
      })
      reject(new Error(`${UPLOAD_MUX_VIDEO_ERROR_MSG}: ${err.detail?.message}`))
    })

    upload.on('offline', () => {
      offlineTimeout = setTimeout(() => {
        upload.abort()
        reject(new Error(`${UPLOAD_MUX_VIDEO_ERROR_MSG}: check your internet connection and try again`))
      }, offlineTimeWait)
    })

    upload.on('online', () => {
      clearTimeout(offlineTimeout)
    })

    upload.on('success', () => {
      window.history.replaceState({}, document.title);
      resolve();
    });
  });

  await uploadFile;
};
